import React, {Component, useEffect, useRef, useState} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import {
    businessLogo,
    businessTitle,
    computeSliderArrows,
    computeSliderCount,
    computeTotalSlides,
    findParent,
    formatTimeAgo,
    updateAnalytics
} from "./utils";

const MessageCarousel = (props) => {
    let result = []
    const ref = useRef()
    const isVisible = useOnScreen(ref)
    let listPresent = props.messageList && props.messageList.length > 0;
    if (isVisible && listPresent) {
        if (props.messageList[0])
            result.push(props.messageList[0].id)
        if (props.messageList[1])
            result.push(props.messageList[1].id)
        if (props.messageList[2])
            result.push(props.messageList[2].id)
        result = ([...new Set(result)])
    }
    if (listPresent) {
        return <MessagesList
            messageList={props.messageList}
            ref={ref}
            PCBID={props.PCBID}
            activeMsgIds={result}
            onClick={(i) => props.onClick(i)}
        />;
    } else {
        return <EmptyList/>;
    }
}


class MessagesList extends Component {
    constructor(props) {
        super(props);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.setTotalSlides = this.setTotalSlides.bind(this);
        this.setSliderCount = this.setSliderCount.bind(this);
        this.setShowArrows = this.setShowArrows.bind(this);
        this.state = {
            totalSlides: computeTotalSlides(this.props.messageList.length, 3),
            sliderCount: computeSliderCount(3),
            showArrows: computeSliderArrows(this.props.messageList.length, 3),
            selectedItem: 0
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.activeMsgIds && nextProps.activeMsgIds.length !== 0 &&
            JSON.stringify(nextProps.activeMsgIds) !== JSON.stringify(this.props.activeMsgIds)) {
            this.setState({
                activeMsgIds: nextProps.activeMsgIds
            }, function () {
                updateAnalytics('post_view', this.state.activeMsgIds, nextProps.PCBID);
            })
        }
    }

    componentWillUnmount() {
        window.clearTimeout(this.throttle);
        window.removeEventListener('resize', this.handleWindowResize, false);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize, false);
    }

    setTotalSlides() {
        const totalSlides = computeTotalSlides(this.props.messageList.length, 3);
        if (this.state.totalSlides !== totalSlides) {
            this.setState({
                totalSlides: totalSlides
            });
        }
    }

    setSliderCount() {
        const sliderCount = computeSliderCount(3);
        if (this.state.sliderCount !== sliderCount) {
            this.setState({
                sliderCount: sliderCount
            });
        }
    }

    setShowArrows() {
        const showArrows = computeSliderArrows(this.props.messageList.length, 3);
        if (this.state.showArrows !== showArrows) {
            this.setState({
                showArrows: showArrows
            });
        }
    }

    handleWindowResize() {
        window.clearTimeout(this.throttle);
        this.throttle = window.setTimeout(this.setTotalSlides, 200);
        this.throttle = window.setTimeout(this.setSliderCount, 200);
        this.throttle = window.setTimeout(this.setShowArrows, 200);
    }

    handleClick = (event, msgId) => {
        let parent = findParent(event.target, 'messaging-list__item')
        let index = parseInt(parent.dataset.key)
        this.props.onClick(index)
        updateAnalytics('post_click', [msgId], this.props.PCBID)
    }


    handleSelectedItem = (e) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            this.setState({selectedItem: e});
        } else if (e + 2 >= this.props.messageList.length) {
            this.setState({selectedItem: this.props.messageList.length - 1});
        } else if (e > 2 && e < 6) {
            this.setState({selectedItem: e});
        } else if (e < 2) {
            this.setState({selectedItem: 0});
        } else {
            this.setState({selectedItem: e});
        }
    }

    viewsCount(defaultValue = null) {
        let result = []
        let elem = defaultValue ? defaultValue : this.state.selectedItem
        let len = this.props.messageList.length - 1
        if (elem <= 0) {
            result.push(this.props.messageList[0].id)
            result.push(this.props.messageList[1].id)
            result.push(this.props.messageList[2].id)
        } else if (elem >= this.props.messageList.length - 1) {
            result.push(this.props.messageList[len - 2].id)
            result.push(this.props.messageList[len - 1].id)
            result.push(this.props.messageList[len].id)
        } else {
            result.push(this.props.messageList[elem - 1].id)
            result.push(this.props.messageList[elem].id)
            result.push(this.props.messageList[elem + 1].id)
        }
        result = ([...new Set(result)])
        updateAnalytics('post_view', result, this.props.PCBID)
    }

    showPrevArrow = (index) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width < 992) {
            return (
                this.state.selectedItem >= 1
            )
        } else {
            return (
                this.state.selectedItem >= 2
            )
        }
    }

    showNextArrow = (index) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width < 992) {
            return (
                this.props.messageList.length > 1 && (this.state.selectedItem + 1 !== this.props.messageList.length)
            )
        } else {
            return (
                this.props.messageList.length > 3 && (this.state.selectedItem + 1 !== this.props.messageList.length)
            )
        }
    }

    displayNextArrow = (clickHandler, hasNext, labelNext) => {
        return (
            this.showNextArrow() && (
                <button onClick={(event) => this.handleNextClick(event, clickHandler)}
                        className="control-arrow control-next">
                </button>
            )
        )
    }

    handleNextClick = (event, clickHandler) => {
        clickHandler()
        this.viewsCount(this.state.selectedItem + 4)
    }

    displayPrevArrow = (clickHandler, hasPrev, labelPrev) => {

        return (
            this.showPrevArrow() && (
                <button onClick={(event) => this.handlePrevClick(event, clickHandler)}
                        className="control-arrow control-prev">
                </button>
            )
        )
    }

    handlePrevClick = (event, clickHandler) => {
        clickHandler()
        this.viewsCount(this.state.selectedItem - 4)
    }

    slidesCount() {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            return 1;
        } else if (this.state.selectedItem === 0 || (this.state.selectedItem === this.props.messageList.length - 1)) {
            return this.state.sliderCount + 1
        } else {
            return this.state.sliderCount;
        }
    }

    render() {
        return (
            <>
                <Carousel
                    showThumbs={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={false}
                    centerMode={true}
                    slidesCount={this.slidesCount()}
                    selectedItem={this.state.selectedItem}
                    onChange={(e) => {
                        this.handleSelectedItem(e)
                    }}
                    centerSlidePercentage={100 / this.state.totalSlides}
                    showArrows={this.state.showArrows}
                    renderArrowNext={(clickHandler, hasNext, labelNext) => this.displayNextArrow(clickHandler, hasNext, labelNext)}
                    renderArrowPrev={(clickHandler, hasPrev, labelPrev) => this.displayPrevArrow(clickHandler, hasPrev, labelPrev)}
                >
                    {this.props.messageList.map((message, index) => (
                        <div
                            className="messaging-list__item"
                            key={index}
                            data-key={index}
                            onClick={(e) => {
                                this.handleClick(e, message.id)
                            }}
                        >
                            <div className="messaging-list__item__block">
                                <img src={message.image.url} alt={message.title} title={document.title}/>
                            </div>
                            <div className="messaging-list__item__desc">
                                <div className="messaging-list__item__top">
                                    <img src={businessLogo(message)} alt={document.title}/>
                                    <ul>
                                        <li><span
                                            className="messaging-list__item__title">{businessTitle(message)}</span>
                                        </li>
                                        <li>{message.sub_category}</li>
                                    </ul>
                                </div>
                                <span className="messaging-list__item__copy">
                                    <h3>{message.title}</h3>
                                </span>
                                <div className="messaging-list__item__bottom ">
                                    <span className="like-count"><i class="fas fa-heart"></i> {message.likes}</span>
                                    <span>{formatTimeAgo(message.time)}</span>
                                </div>

                            </div>
                        </div>
                    ))}
                </Carousel>
            </>
        );
    }
}

function useOnScreen(ref) {
    const [isIntersecting, setIntersecting] = useState(false)

    function setElement(entry) {
        setIntersecting(entry.isIntersecting)
    }

    const observer = new IntersectionObserver(([entry]) => setElement(entry))
    useEffect(() => {
        observer.observe(document.getElementById('messaging'))
        return () => {
            observer.disconnect()
        }
    }, [observer])
    return isIntersecting
}


function EmptyList(props) {
    return <h1> No messages </h1>;
}

export default MessageCarousel;
